import type { ISlidePackage } from 'app/typings/slides';

export function formatPackageName(
  pkg: Pick<ISlidePackage, 'name' | 'hotelName'>
): string {
  return `${pkg.hotelName} - ${pkg.name}`;
}
